import { convertLabelMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.TestNumber`]: 'Test Number',
      [`${prefix}.Preparation.Weather`]: 'Weather',
      [`${prefix}.Preparation.LayerThickness`]: 'Layer Thickness',
      [`${prefix}.Preparation.SandUsedToBedGauge`]: 'Sand used to bed gauge',
      [`${prefix}.Preparation.NuclearDensityGauge`]: 'Nuclear Density Gauge',
      [`${prefix}.Preparation.NuclearGaugeSerialNumber`]: 'Serial Number:',
      [`${prefix}.Preparation.NuclearGaugeMakeModel`]: 'Make/Model:',
      [`${prefix}.Preparation.ApplyCorrectionsToMeasurements`]: 'Apply corrections to measurements',
      [`${prefix}.Preparation.BulkDensityCorrectionSlope`]: 'Slope (b)',
      [`${prefix}.Preparation.BulkDensityCorrectionIntercept`]: 'Intercept',

      [`${prefix}.TheoreticalMaximumDensity.MaximumDensityFrom`]: 'Maximum Density From',
      [`${prefix}.TheoreticalMaximumDensity.MaximumLabDensity`]: 'Maximum Theoretical Density',
      [`${prefix}.TheoreticalMaximumDensity.ImportedAsphaltMix`]: 'Mix Design',

      [`${prefix}.Measurements.GaugeMode`]: 'Mode',
      [`${prefix}.Measurements.ObtainAdditionalReading`]: 'Obtain Additional Reading',
      [`${prefix}.Measurements.ProbeDepth`]: 'Probe Depth',
      [`${prefix}.Measurements.AverageCorrectedBulkDensity`]: 'Corrected Bulk Density',
      [`${prefix}.Measurements.Readings.BulkDensity`]: 'Bulk Density',
      [`${prefix}.Measurements.Readings.CorrectedBulkDensity`]: 'Corrected Bulk Density',

      [`${prefix}.Results.BulkDensity`]: 'Bulk Density',
      [`${prefix}.Results.TheoreticalMaximumDensity`]: 'Theoretical Maximum Density',
      [`${prefix}.Results.RelativeCompaction`]: 'Relative Compaction (%)',
      [`${prefix}.Results.AirVoids`]: 'Air Voids (%)',
      [`${prefix}.Results.ReportAirVoids`]: 'Air Voids',
    })
  );

export default getLabelConfig;
